export const COLLECTIONS = {
  VACATION_REQUESTS: 'vacation_requests',
  USERS: 'users',
  TENANTS: 'tenants',
  CONFIG: 'config',
};
